import * as React from "react";
import ReactJWPlayer from "react-jw-player";
import { saveAnalyticsEvent } from "src/api";
import Spinner from "src/components/Spinner";
import { ContentLanguage } from "src/types";
import { useAppContext } from "../../context/AppContext";
import HTMLRender from "./HTMLRender";
import Image360 from "./Image360";
import {
  ContentItem,
  HTMLContentWrapper,
  Image,
  JWVideoPlayerWrapper,
  Link,
  LinkButton,
  LinkImage,
  MediaContentWrapper,
  NoContentToView,
} from "./styled";

const Content = ({ selectedExhibitId }) => {
  const { getContentForLanguage, getSelectedContents, hasCoordinates } =
    useAppContext();

  const content = getSelectedContents(selectedExhibitId);

  const [isScriptLoaded, setIsScriptLoaded] = React.useState(false);

  React.useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.jwplayer.com/libraries/EI5i6PzB.js";
    script.async = true;
    script.onload = () => setIsScriptLoaded(true);
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const renderItem = (item, index) => {
    let langContent: ContentLanguage = getContentForLanguage(item);
    if (item.type === "text") {
      return (
        <HTMLContentWrapper key={index}>
          <HTMLRender content={langContent.content} />
        </HTMLContentWrapper>
      );
    } else if (item.type === "image360") {
      return (
        <MediaContentWrapper key={index}>
          <Image360 url={langContent.fileUrl} />
        </MediaContentWrapper>
      );
    } else if (item.type === "image") {
      const displayURL = langContent.fileUrlThumb || langContent.fileUrl;
      return (
        <MediaContentWrapper key={index}>
          <Image as="img" src={displayURL} alt={langContent.description} />
        </MediaContentWrapper>
      );
    } else if (item.type === "webview") {
      return langContent.fileUrl ? (
        <HTMLContentWrapper
          as="div"
          key={index}
          style={{ textAlign: "center" }}
        >
          <Link
            as="a"
            href={langContent.url}
            onClick={() => {
              saveAnalyticsEvent("Button_Analytics", { id: item.id });
            }}
          >
            <LinkImage
              as="img"
              src={langContent.fileUrl}
              alt={langContent.description}
            />
          </Link>
        </HTMLContentWrapper>
      ) : (
        <HTMLContentWrapper as="a" key={index} style={{ textAlign: "center" }}>
          <LinkButton
            as="button"
            onClick={() => {
              window.open(langContent.url, "_self");
              saveAnalyticsEvent("Button_Analytics", { id: item.id });
            }}
          >
            {langContent.title}
          </LinkButton>
        </HTMLContentWrapper>
      );
    } else if (
      item.type === "video" &&
      langContent.fileName &&
      langContent.fileName.trim().length > 0
    ) {
      return (
        <JWVideoPlayerWrapper>
          {/* <ReactJWPlayer
            playerId={`${Date.now()}-${langContent.content}-jw-player`}
            // playerScript="https://cdn.jwplayer.com/libraries/EI5i6PzB.js"
            playerScript="https://cdn.jwplayer.com/libraries/latest.js"
            playlist={`https://cdn.jwplayer.com/v2/media/${langContent.content}`}
            image={`https://content.jwplatform.com/thumbs/${langContent.content}.jpg`}
          /> */}
          {isScriptLoaded && (
            <ReactJWPlayer
              playerId={`${Date.now()}-${langContent.content}-jw-player`}
              playerScript="https://cdn.jwplayer.com/libraries/latest.js"
              playlist={`https://cdn.jwplayer.com/v2/media/${langContent.content}`}
              image={`https://content.jwplatform.com/thumbs/${langContent.content}.jpg`}
            />
          )}
        </JWVideoPlayerWrapper>
      );
    }
    return null;
  };

  return (
    <div
      id={`exhibit_${selectedExhibitId}`}
      style={{
        minHeight: "350px",
        marginBottom: hasCoordinates ? "100px" : "20px",
      }}
    >
      {!selectedExhibitId ? (
        <Spinner />
      ) : (
        <>
          {content.length > 0 ? (
            content.map((item, index) => {
              return (
                <ContentItem as="div" key={index}>
                  {renderItem(item, index)}
                </ContentItem>
              );
            })
          ) : (
            <NoContentToView>No Content To View</NoContentToView>
          )}
        </>
      )}
    </div>
  );
};

export default Content;
